// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.navigation-drawer--temporary .v-list-item__action {\n  padding-left: 12px;\n}\n.v-list-item__action {\n  padding-left: 12px;\n  text-align: left !important;\n}\n\n/*.v-navigation-drawer--mini-variant .v-list-item__action {*/\n/*  padding-left: unset;*/\n/*}*/\n.main-menu-panel {\n  z-index: 8;\n  margin-bottom: 36px;\n  width: 80px;\n}\n", ""]);
// Exports
module.exports = exports;
